import { useTranslate } from '@growtherapy/i18n';
import { Button, Text, useRebrand } from '@growtherapy/sprout-ui';

export type VibesCtaProps = {
  openPreSessionVibes: () => void;
};

export function VibesCta({ openPreSessionVibes }: VibesCtaProps) {
  const t = useTranslate();
  const isRebrand = useRebrand();

  return (
    <>
      <Text data-testid='pre-session-prompt-vibes' className='font-medium rebrand:text-text-inverse'>
        {t('telehealth-core:waitingRoom.inTheMeantimeTakeAMomentTo')}
      </Text>
      <Button
        className='flex gap-4 justify-center items-center w-full rebrand:w-component-700'
        onClick={openPreSessionVibes}
        use={isRebrand ? 'secondary' : 'primary'}
      >
        {t('telehealth-core:waitingRoom.unwindWhileYouWait')}
      </Button>
    </>
  );
}
